import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import {
  Container,
  Typography,
  Card,
  CardContent,
  CardMedia,
} from "@mui/material";
import Slider from "react-slick";
import Footer from "../../component/footer";
import Intro from "../../component/Intro";
import "../../component/component.css";
import loadingGif from '../CMD/loading.gif';
import ImageModal from "./ImageModal"; // Import the ImageModal component
import parse from 'html-react-parser'; // Importing the html-react-parser library

const Projectdetail = ({ mode, setmymode }) => {
  const { id } = useParams();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalImages, setModalImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState("");

  useEffect(() => {
    const fetchProject = async () => {
      try {
        const response = await axios.get(`https://sirius.runasp.net/api/Project/${id}`);
        setProject(response.data);
      } catch (error) {
        console.error("Error fetching project details", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProject();
  }, [id]);

  const handleImageClick = (imageSrc) => {
    setModalImages(project.photos.map(photo => `https://sirius.runasp.net/${photo.filePath}`));
    setSelectedImage(imageSrc);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedImage("");
  };

  const settings = (photoCount) => ({
    dots: photoCount > 1,
    infinite: photoCount > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    appendDots: dots => (
      <div style={{ padding: '10px' }}>
        <ul style={{ margin: '0px', padding: '0px' }}> {dots} </ul>
      </div>
    ),
    customPaging: i => (
      <div
        className="custom-dot"
        style={{
          width: '10px',
          height: '10px',
          background: 'lightcoral',
          borderRadius: '50%',
          display: 'inline-block',
          margin: '0 5px'
        }}
      />
    ),
  });
  const span = (
    <span style={{ 
      color: "#fff", 
      fontSize: '2rem', 
      display: 'block', 
      wordWrap: 'break-word', 
      lineHeight: '1.2',
      whiteSpace: 'normal', // Allows the text to wrap to the next line
      overflowWrap: 'break-word', // Breaks long words if necessary
    }}>
      {project?.name}
    </span>
  );
  const textinline = {
    headh1: "",
    spano: span,
  };

  if (loading) {
    return (
      <div style={{ margin:'50px auto', textAlign:'center',  width:'200px',height:'200px' }}>
        <img width={'100%'} src={loadingGif} alt="Loading..." />
      </div>
    );
  }

  if (!project) {
    return <Typography variant="h6">Project not found</Typography>;
  }

  return (
    <div>
      <Intro mode={mode} setmymode={setmymode} textinline={textinline} />
      <Container style={{ padding: "2rem 50px 20px 50px", borderColor: mode === 'dark' ? 'lightcoral' : 'silver' }}>
        <Card sx={{ borderColor: mode === 'dark' ? 'lightcoral' : 'silver' }}>
          {project.photos && (
            <Slider {...settings(project.photos.length)}>
              {project.photos.map((photo, index) => (
                <div key={index} style={{ width: '100%' }}>
                  <CardMedia
                    component="img"
                    height="500"
                    image={`https://sirius.runasp.net/${photo.filePath}`}
                    alt={`Project ${project.id} ${index}`}
                    style={{
                      width: '100%',
                      objectFit: 'cover',
                      borderRadius: '10px',
                      cursor: 'pointer',
                    }}
                    onClick={() => handleImageClick(`https://sirius.runasp.net/${photo.filePath}`)}
                  />
                </div>
              ))}
            </Slider>
          )}
          <CardContent>
            <Typography variant="h3" component="h2" fontWeight="bold">
              {project.name}
            </Typography>
            <Typography variant="body1" mt={2}>
            {parse(project.description, 50)} {/* Parsing HTML content */}
            </Typography>
          </CardContent>
        </Card>
      </Container>
      {modalOpen && (
        <ImageModal
          images={modalImages}
          initialImage={selectedImage}
          onClose={handleCloseModal}
        />
      )}
      <Footer />
    </div>
  );
};

export default Projectdetail;
